import React from 'react';
import propTypes from 'prop-types';
import { groupBy } from 'lodash';
import ErrorsSection from './ErrorsSection';
import { Grid, Typography } from '@metarouter-private/mr-mui';
import { useTrackPage } from '@ion/api';

export default function PlaybookTransformationErrors({ outputErrors }) {
  useTrackPage('input_event_error_received');

  const groupedErrors = groupBy(outputErrors, 'type');
  const errorTypes = Object.keys(groupedErrors).sort();

  return (
    <Grid direction="column" container padding={1} paddingTop={0}>
      <Typography align="center" variant="h5">
        Unable to transform event
      </Typography>
      {errorTypes.map(errorType => (
        <ErrorsSection key={errorType} errorType={errorType} errors={groupedErrors[errorType]} />
      ))}
    </Grid>
  );
}

PlaybookTransformationErrors.propTypes = {
  outputErrors: propTypes.array.isRequired,
};
